function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React from "react";
import { useUIDSeed } from "react-uid";
import { Section, SectionHeader } from "../../molecules";
import { TeamCardsCard } from "../../molecules/TeamCardsCard";
export var TeamCardsSection = function(param) {
    var label = param.label, title = param.title, callToActions = param.callToActions, cards = param.cards, className = param.className, enableLines = param.enableLines;
    var seed = useUIDSeed();
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "dark" : false,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-auto gap-7 md:gap-10"
    }, /*#__PURE__*/ React.createElement(SectionHeader, {
        label: label,
        title: title,
        callToActions: callToActions
    }), /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-7 md:grid-cols-3"
    }, cards.map(function(card) {
        return /*#__PURE__*/ React.createElement(TeamCardsCard, _extends({
            key: seed(card)
        }, card));
    }))));
};

//# sourceMappingURL=TeamCardsSection.js.map